<template>
  <div class="chart-wrapper">
    <canvas ref="canvas"></canvas>
  </div>
</template>

<script lang="ts" setup>
import {onBeforeUnmount, onMounted, ref, watch} from "vue";
import {BarController, BarElement, CategoryScale, Chart, LinearScale, Tooltip} from "chart.js";

Chart.register(BarController, BarElement, CategoryScale, LinearScale, Tooltip);

// eslint-disable-next-line no-undef
const props = defineProps<{
  labels: string[];
  values: number[];
  label?: string;
}>();

const canvas = ref<HTMLCanvasElement>();
let chart: Chart | undefined;

function renderChart() {
  if (!canvas.value)
    return;

  chart?.destroy();
  chart = new Chart(canvas.value, {
    type: "bar",
    data: {
      labels: props.labels,
      datasets: [{
        label: props.label,
        data: props.values,
        backgroundColor: "#009DE2"
      }]
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {legend: {display: false}},
      scales: {y: {beginAtZero: true, ticks: {precision: 0}}}
    }
  });
}

onMounted(renderChart);
watch(() => [props.labels, props.values], renderChart, {deep: true});
onBeforeUnmount(() => chart?.destroy());
</script>

<style scoped lang="scss">
.chart-wrapper {
  position: relative;
  height: 240px;
}
</style>
